import {Component} from '@angular/core';

@Component({
    // selector: 'demo',
    template: `<h1>Hello </h1><br><br><hr><h2>This is good</h2>`,
})

export class DemoComponent {
}